import useAuth from './useAuth';
import authInstance from './../utilities/axios/authInstance';

const useLogout = () => {
    const {auth, setAuth} = useAuth();

    const logout = async () => {
        const token = auth?.token;

        try {
            // attempt to blacklist the jwt token too 
            const response = await authInstance.post('auth/logout', {
                headers: {
                    'Authorization': "Bearer " + token
                }
            });

            setAuth({}); // reset setAuth({}) if token is blacklisted 
        } catch (error) {
            console.log(error);
            
        }
    }

    return logout;
}

export default useLogout;